import { Module, Action, getModule } from 'vuex-module-decorators';
import PageBaseModule from '@/store/page';
import store from '@/store';
import PageEntity from '@/store/pageEntity';
import { getList } from '@/api/crud';
import ResponseHandlerModule from '@/store/modules/responseHandler';

import ConsultationsFilter from './filterEntity';
import FilterModel from './filterModel';

import { Consultations } from '@/models/consultations';
import { TableApiInterface } from '@/types/page/table';
import { getDateAndTime } from '@/utils/date';

export const MODULE_NAME = Consultations.moduleName;

const filterModel = new FilterModel();
const filter = getModule(ConsultationsFilter);

filter.setFilterName('clinicsFilter');
filter.setTemplateClassName('template-lg');
filter.setFilterModel(filterModel.filterModel);
filter.setFilterHandlers(filterModel.filterHandlers);

@Module({ dynamic: true, store, name: MODULE_NAME, namespaced: true })
class ConsultationsModule extends PageBaseModule {
    filter = filter;

    constructor(module: ConsultationsModule) {
        super(module);

        const page = new PageEntity();
        page.setTitle(Consultations.listTitle);
        page.setTitleAdd(Consultations.createTitle);
        page.values.actionPagination = 'consultations/updatePage';
        page.values.actionPageAmountItems = 'consultations/updatePageAmountItems';
        page.values.pageAmountItems = 50;
        
        this.pageSettings = page.values;
        this.pageSettings.routeName = Consultations.entityName;
        this.pageSettings.routeParam = `id`;
    }

    @Action({ rawError: true })
    async setPatientId(patientId: string) {
        filter.SET_SEARCH({ key: 'patientId', value: patientId });
        filter.updateFilter();
    }

    @Action({ rawError: true })
    async init() {
        await this.getList();
    }

    @Action({ rawError: true })
    async getList() {
        try {
            const sort = await this.getSortForRequest();
            const result = await getList(
                Consultations.moduleName,
                {
                    page: this.pageSettings.pageCurrent,
                    items: this.pageSettings.pageAmountItems,
                },
                sort,
                this.filter.filterSettings.filter,
            );
            const table = await this.prepareList(result.table);
            await this.context.dispatch('setList', table);
        } catch (error) {
            if (error.response?.data) {
                ResponseHandlerModule.showNotify({ message: error.response.data, type: 'fail' });
                return;
            }
            ResponseHandlerModule.showNotify({ message: error, type: 'fail' });
        }
    }

    @Action({ rawError: true })
    prepareList(table: TableApiInterface): TableApiInterface {
        table.rows = table.rows.map(row => {
            if (row.receptionDatetime) {
                row.receptionDatetime = getDateAndTime(row.receptionDatetime);
            }

            return row;
        });

        return table;
    }
}

export default getModule(ConsultationsModule);